export default function About(){
    return(
        <div className="about">
            <h3>About</h3>
            <p>I'm a web developer. I love coding and exploring new stuff. I like contributing to open-source projects,
                 exploring the frontier of web development and interested in learning new technologies.
            </p>
        </div>
    )
}